module.exports = __webpack_public_path__ + "static/media/dr-fernando-proenca.f58bcd76.webp";